import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  & h5 {
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    color: #555658;
    text-transform: uppercase;
  }

  & button {
    border: 0;
    background: #fff;
    color: #555658;

    & svg {
      width: 20px;
      height: 20px;
    }
  }
`;
